import React from 'react'

export const tradeInConfig = [
  {
    categoryIds: ['29959'], // Mobile phones and accessories
    excludedCategoryIds: ['30144'], // smart watches
    heading: 'Trade in your old phone.',
    subtext: (
      <>
        Receive between <strong>£19 - £320.</strong> Get your estimated value here.
      </>
    )
  },
  {
    categoryIds: [
      '29960', // Tablets and iPad
      '30621', // Fitness and activity trackers
      '1054684', // Nintendo Switch 2 consoles
      '812421', // PS5 consoles
      '812425', // Xbox Series X consoles
      '823765', // Xbox Series S consoles
      '30144', // smart watches
      '30293' // nintendo switch consoles
    ],
    heading: 'Trade in your old device',
    subtext: 'Get your estimated value here.'
  },
  {
    categoryIds: ['29953'], // Laptops and PCs
    excludedCategoryIds: ['30274'], // iMacs
    brand: 'Apple',
    heading: 'Trade in your old device',
    subtext: 'Get your estimated value here.'
  },
  {
    skus: [
      '7791745',
      '7793327',
      '7780615',
      '7790605',
      '7808535',
      '7787890',
      '7799187',
      '7799266',
      '7799077',
      '7790791',
      '7802249',
      '7790069',
      '7804230',
      '7791941',
      '7792892',
      '7785854',
      '7785191',
      '7801288',
      '7788394',
      '7793695',
      '7796719',
      '7784484',
      '7801082',
      '7796348',
      '7781274',
      '7788624',
      '7780275',
      '7793918',
      '7795095',
      '7799651',
      '7797419',
      '7780859',
      '7804694',
      '7784745',
      '7801154',
      '7793585',
      '7795459',
      '7782015',
      '7785469',
      '7795992',
      '7790612',
      '7788387',
      '7791501'
    ], // Apple iPhone 17 & iPhone Air skus
    heading: 'Get an extra £50 when you upgrade',
    subtext: 'Plus trade in your phone for £63-£540'
  }
]

const hasMatchingCategory = (config, breadcrumbIds) => {
  return config.categoryIds.some(id => breadcrumbIds.includes(id))
}

const hasMatchingSku = (config, sku) => {
  return config.skus && config.skus.includes(sku)
}

const isExcludedCategory = (config, breadcrumbIds) => {
  if (!config.excludedCategoryIds) return false
  return config.excludedCategoryIds.some(excluded => breadcrumbIds.includes(excluded))
}

const isBrandMismatch = (config, brand) => {
  return config.brand && config.brand !== brand
}

/**
 * Finds the matching trade-in category configuration for a product
 * @param {Array} breadcrumb
 * @param {string} brand
 * @returns {Object|undefined}
 * @param {string} sku
 */
export const getTradeInConfig = (breadcrumb, brand, sku) => {
  const breadcrumbIds = breadcrumb?.map(crumb => crumb.id) ?? []

  const skuConfig = tradeInConfig.find(
    config => config.skus && hasMatchingSku(config, sku) && !isBrandMismatch(config, brand)
  )
  if (skuConfig) return skuConfig

  return tradeInConfig.find(
    config =>
      !config.skus &&
      hasMatchingCategory(config, breadcrumbIds) &&
      !isBrandMismatch(config, brand) &&
      !isExcludedCategory(config, breadcrumbIds)
  )
}
